<template>
    <div class="product-select-spinner">
        <p class="input-clue">{{$t('productSelectSpinner.chooseClue')}}</p>
        <div class="spinner-container" ref="spinnerContainer" @click.stop>
            <div class="result-box" :class="{active: showPop}" @click="showPop=!showPop">
                <input class="result-input" type="text" :value="selectedProductText" :placeholder="placeholder">
                <span class="arrow-icon icon-icon_arrow-down"></span>
                <span class="required-icon">*</span>
            </div>
            <div class="drop-down-box" v-show="showPop">
                <div class="input-box">
                    <input type="text" v-model="searchText">
                    <span class="icon-icon_search-2"></span>
                </div>
                <ul class="product-list">
                    <li class="no-match" v-show="filteredProductList.length===0">
                        {{$t('productSelectSpinner.notAvailable')}}
                    </li>
                    <li class="product-item"
                    :class="{ active: selectedProduct.indexOf(item.product) !== -1 }"
                    v-for="(item, index) in filteredProductList"
                    :key="index"
                    @click="chooseProduct(item.product)">
                        <img :src="item.img" >
                        <span>{{item.product}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <reo-dialog
            @cancel="showSubscription = false"
            v-show="showSubscription">
                <email-subscription subject="cloud-other-products-ready"></email-subscription>
        </reo-dialog>
    </div>
</template>
<script>
import { getCloudConfig } from '@/api/s3Config';
import emailSubscription from '@/components/emailSubscription';
import reoDialog from '@/basic/Dialog';

export default {

    name: 'productSelectSpinner',
    components: {

        emailSubscription,
        reoDialog

    },

    data () {

        return {

            searchText: '',
            selectedProduct: [],
            showPop: false,
            placeholder: this.$t( 'productSelectSpinner.placeholder' ),
            supportedProductList: [],
            showSubscription: false

        };

    },
    async created () {

        let cloudConfig = await getCloudConfig();
        this.supportedProductList = cloudConfig.productSupported;

    },
    computed: {

        filteredProductList () {

            if ( !this.searchText ) {

                return this.supportedProductList.slice();

            }

            const text = this.searchText.toLowerCase();

            return this.supportedProductList.filter( item => item.product.toLowerCase().includes( text ));

        },

        selectedProductText () {

            if ( this.selectedProduct.length ) {

                return this.selectedProduct.join( ', ' );

            }
            return '';

        }

    },
    watch: {

        showPop ( n ) {

            if ( n ) {

                document.addEventListener( 'click', this.clickListener );

            } else {

                this.searchText = '';
                document.removeEventListener( 'click', this.clickListener );

            }

        },

        selectedProduct ( n ) {

            this.$emit( 'productSelect', this.selectedProduct );

        }

    },
    methods: {

        clickListener ( e ) {

            this.showPop = false;

        },
        chooseProduct ( product ) {

            if ( this.selectedProduct.indexOf( product ) === -1 ) {

                this.selectedProduct.push( product );

            } else {

                for ( let index in this.selectedProduct ) {

                    if ( this.selectedProduct[index] === product ) {

                        this.selectedProduct.splice( index, 1 );

                    }

                }

            }

        }

    }

};
</script>
<style lang='less' scoped>
.product-select-spinner {
    margin-bottom: 20px;
    font-size: 16px;
    text-align: left;
    position: relative;
    @media @mobile {
        margin-bottom: 0.2rem;
        font-size: 0.24rem;
    }
    input {
        width: 100%;
        outline-offset: 0;
        border: none;
        font-size: 16px;
        padding: 0;
        box-sizing: border-box;
        @media @mobile {
            font-size: 0.24rem;
        }
    }
    .input-clue {
        margin-bottom: 20px;
        @media @mobile {
            margin-bottom: 0.3rem;
        }
    }
    .spinner-container {
        position: relative;
        z-index: 3;
        .result-box {
            display: flex;
            align-items: center;
            border-radius: 8px;
            box-shadow: 0px 0px 6px 2px rgba(0, 0, 0, 0.14);
            border: 1px solid transparent;
            padding-left: 30px;
            padding-right: 30px;
            position: relative;
            box-sizing: border-box;
            cursor: pointer;
            @media @mobile {
                border-radius: 0.08rem;
                padding-left: 0.4rem;
                padding-right: 0.32rem;
            }
            .result-input {
                pointer-events: none;
                height: 48px;
                user-select: none;
                @media @mobile {
                    height: 0.78rem;
                }
            }
            &.active {
                border-color: @theme;
                box-shadow: none;
            }
            .arrow-icon {
                font-size: 16px;
                color: @theme;
                position: absolute;
                top: 50%;
                pointer-events: none;
                transform: translateY(-50%);
                right: 30px;
                font-weight: 500;
                @media @mobile {
                    font-size: 0.26rem;
                    right: 0.32rem;
                }
            }
            .required-icon {
                position: absolute;
                color: #e74330;
                right: -10px;
                font-size: 18px;
                top: 0;
                @media @mobile {
                    font-size: 0.32rem;
                    right: -0.15rem;
                }
                @media screen and (max-width: 500px) {
                    right: -0.2rem;
                }
            }
        }
        .drop-down-box {
            background-color: #fff;
            border: 1px solid @theme;
            border-top: none;
            width: ~"calc(100% - 0.1rem)";
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate(-50%, 100%);
            .input-box {
                padding: 0 4px;
                position: relative;
                @media @mobile {
                    padding: 0 0.04rem;
                }
                input {
                    padding: 0 20px;
                    height: 36px;
                    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
                    @media @mobile {
                        padding: 0 0.36rem;
                        height: 0.76rem;
                    }
                }
                .icon-icon_search-2 {
                    color: #777;
                    font-size: 16px;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    right: 24px;
                    pointer-events: none;
                    @media @mobile {
                        font-size: 0.28rem;
                        right: 0.24rem;
                    }
                }
            }
            .product-list {
                max-height: 180px;
                width: 100%;
                padding: 0 24px 26px 56px;
                text-align: left;
                box-sizing: border-box;
                overflow-y: auto;
                font-size: 0;
                @media @mobile {
                    max-height: 3.08rem;
                    padding: 0.26rem 0.36rem;
                }
                .no-match {
                    margin-top: 26px;
                    margin-right: 30px;
                    display: inline-block;
                    font-size: 16px;
                    color: #999;
                    .notify-btn {
                        color: @theme;
                        cursor: pointer;
                        &:hover {
                            text-decoration: underline;
                        }
                    }
                    @media @mobile {
                        margin-top: 0;
                        display: block;
                        margin-right: 0;
                        font-size: 0.24rem;
                    }
                }
                .product-item {
                    cursor: pointer;
                    margin-top: 26px;
                    margin-right: 30px;
                    width: 184px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    display: inline-block;
                    font-size: 0;
                    @media @mobile {
                        display: block;
                        margin-top: 0.5rem;
                        margin-right: 0;
                        width: auto;
                        &:nth-of-type(2) {
                            margin-top: 0;
                        }
                    }
                    img {
                        margin-right: 12px;
                        width: 38px;
                        vertical-align: middle;
                        display: inline-block;
                        @media @mobile {
                            margin-right: 0.24rem;
                            width: 0.4rem;
                        }
                    }
                    span {
                        font-size: 16px;
                        color: #999;
                        vertical-align: middle;
                        @media @mobile {
                            font-size: 0.26rem;
                        }
                    }
                    &.active,
                    &:hover {
                        span {
                            color: @theme;
                        }
                    }
                }
            }
        }
    }
    .spinner-clue {
        margin-top: 20px;
        font-size: 14px;
        color: #e74330;
        line-height: 1.2;
        @media @mobile {
            margin-top: 0.2rem;
            font-size: 0.24rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/productSelectSpinner.vue